import { EEthereumNetworkId } from '@ankr.com/provider';

import { GetTasksItem } from './actions/getTasks';

type GroupedTasksData = {
  chainId: EEthereumNetworkId;
  address: string;
  tasks: GetTasksItem[];
}[];

export function getGroupedTasksData(tasks: GetTasksItem[]): GroupedTasksData {
  const chainGroupedTasks = new Map<EEthereumNetworkId, GetTasksItem[]>();

  tasks.forEach(task => {
    const { chainId } = task;
    const itemTasks = chainGroupedTasks.get(chainId);
    if (itemTasks?.length) {
      chainGroupedTasks.set(chainId, [...itemTasks, task]);
      return;
    }

    chainGroupedTasks.set(chainId, [task]);
  });

  const groupedTasksData: GroupedTasksData = [];

  chainGroupedTasks.forEach((itemTasks, keyChainId) => {
    const addressTasks = new Map<string, GetTasksItem[]>();

    itemTasks.forEach(task => {
      const addressKey = task.cronTarget ?? task.target;
      const addressItemTasks = addressTasks.get(addressKey);

      if (addressItemTasks?.length) {
        addressTasks.set(addressKey, [...addressItemTasks, task]);
        return;
      }

      addressTasks.set(addressKey, [task]);
    });

    addressTasks.forEach((addressItemTasks, address) => {
      groupedTasksData.push({
        address,
        chainId: Number(keyChainId) as EEthereumNetworkId,
        tasks: addressItemTasks,
      });
    });
  });

  return groupedTasksData;
}
